import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  withStyles,
  Grid,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  Switch,
  // Paper,
  // Select,
  // MenuItem,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import Swal from 'sweetalert2';
import './styles/dialog.css';
import './styles/devicesview.css';
import { withTranslation } from 'react-i18next';
import IntegrationReactSelect from '../Select/Select';

class Devices extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = this.props.state;
  }

  handleSubmit = async () => {
    const { t } = this.props;
    let { data } = this.props.patient.toJS();
    if (data.patient && data.patient.devices.length > 2) {
      Swal.fire({
        html: `<h4> Can not assigned device more than 2`,
        confirmButtonText: `${t('ok')}`,
        type: 'warning',
        // width: 300,
        customClass: {
          container: 'my-swal',
        },
      });
    } else {
      await this.props.dashboard.assignDevice(data.patient.devices, data.patient.id);
      this.props.handleClose();
    }
  };

  // handleAddDevice = async () => {
  //   const { t } = this.props;
  //   let { data, devices } = this.props.patient.toJS();
  //   if (data.patient && devices.selected.id !== 0) {
  //     if (data.patient.devices.length >= 1) {
  //       Swal.fire({
  //         html: `<h4>${t("device_is_already")}</h4>${t("do_you_still")}`,
  //         type: "warning",
  //         confirmButtonText: `${t("confirm")}`,
  //         showCancelButton: true,
  //         reverseButtons: true,
  //         customClass: {
  //           container: "my-swal",
  //         },
  //         cancelButtonText: `${t("cancel")}`,
  //       }).then(async (result) => {
  //         if (result.value) {
  //           await this.props.patient.remoteDeleteDevice(0);
  //           await this.props.patient.addDevice();
  //           this.props.patient.resetDeviceSelect();
  //         }
  //       });
  //     } else {
  //       await this.props.patient.addDevice();
  //       this.props.patient.resetDeviceSelect();
  //     }
  //   } else {
  //     Swal.fire({
  //       html: `${t("please_select")}`,
  //       confirmButtonText: `${t("ok")}`,
  //       type: "warning",
  //       // width: 300,
  //       customClass: {
  //         container: "my-swal",
  //       },
  //     });
  //   }
  // };

  handleAddDevice = async () => {
    const { t } = this.props;
    const { data, devices } = this.props.patient.toJS();
    if (data.patient && devices.selected.id !== 0) {
      const deviceAssign = data.patient.devices.filter(
        (d) => d.deviceVersion.category === devices.selected.value.deviceVersion.category,
      );
      if (deviceAssign.length > 0) {
        Swal.fire({
          html: `<h4>${t('do_you_still')}`,
          type: 'warning',
          confirmButtonText: `${t('confirm')}`,
          showCancelButton: true,
          reverseButtons: true,
          customClass: {
            container: 'my-swal',
          },
          cancelButtonText: `${t('cancel')}`,
        }).then(async (result) => {
          if (result.value) {
            await this.props.patient.remoteDeleteDevice(deviceAssign);
            await this.props.patient.addDevice();
            this.props.patient.resetDeviceSelect();
          }
        });
      } else {
        await this.props.patient.addDevice();
        this.props.patient.resetDeviceSelect();
      }
    } else {
      Swal.fire({
        html: `${t('please_select')}`,
        confirmButtonText: `${t('ok')}`,
        type: 'warning',
        // width: 300,
        customClass: {
          container: 'my-swal',
        },
      });
    }
  };

  onSelectCategory = async (e) => {
    this.props.deviceType.setAction('category', e);
    if (e) {
      const subgroupId = this.props.data ? this.props.data.subGroupId : this.props.patientData.subGroupId;
      let devices = await this.props.dashboard.getDeviceList(subgroupId, e.value);
      if (e.value === 'EMERGENCY_BUTTON') {
        // devices = devices.filter(d => d.deviceVersion.name.includes('Wearable'))
        devices = devices
          .map((d) => {
            const deviceProperty =
              d.deviceVersion && d.deviceVersion.property ? JSON.parse(d.deviceVersion.property) : null;
            d.deviceVersion.property = deviceProperty;
            return d;
          })
          .filter((val) => val.deviceVersion && val.deviceVersion.property.localization);
      }
      this.props.patient.setDeviceList(devices);
    }
  };

  onDeviceChange = (e) => {
    this.props.patient.setDeviceSelect(e);
  };

  // handleDelete = (deletedRows) => {
  //   const deletedIndexes = Object.keys(deletedRows.lookup);
  //   this.props.patient.remoteDelete(deletedIndexes);
  // };

  handleDeleteChange(index) {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('unassign_device')}<h4>${t('unassign_device2')}`,
      type: 'warning',
      confirmButtonText: `${t('unassign')}`,
      cancelButtonText: `${t('cancel')}`,
      showCancelButton: true,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        this.props.patient.unAssignDevice(index);
      }
    });
  }

  handleChange = (id) => (event) => {
    this.props.patient.activateDevice(id, event.target.checked);
  };

  getFullname = (language, data) => {
    let fullname = '';
    if (language && language === 'th-TH') {
      if (data.firstname || data.lastname) {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      } else {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      }
    }

    if (language && language === 'en-EN') {
      if (data.firstnameEn || data.lastnameEn) {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      } else {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      }
    }

    return fullname;
  };

  render() {
    let { state, t } = this.props;
    const { categories, category } = this.props.deviceType.toJS();
    const showActivateButton = false;
    const patient = this.props.data ? this.props.data.patient : this.props.patientData.patient;
    // const showActivateButton =
    //   patient &&
    //   patient.devices &&
    //   patient.devices
    //     .map((value) =>
    //       value.deviceVersion
    //         ? JSON.parse(value.deviceVersion.property).activateButton
    //         : 0
    //     )
    //     .some((value) => value);

    const fullname = this.getFullname(localStorage.getItem('i18nextLng'), patient);

    const columns = [
      {
        name: 'id',
        label: 'ID',
        options: {
          display: false,
        },
      },
      {
        name: 'name',
        label: `${t('device_name')}`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'serial',
        label: 'Serial No.',
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
      {
        name: 'status',
        label: 'Status',
        options: {
          display: false,
        },
      },
      {
        name: 'deviceVersion.name',
        label: `${t('type')}`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'activate',
        label: `${t('activate')}`,
        options: {
          display: showActivateButton ? true : false,
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <Switch
                checked={row && row[3] === 'ACTIVATE_ON' ? true : false}
                onChange={this.handleChange(row && row[0])}
                value='activate'
                color='primary'
                inputProps={{ 'aria-label': 'primary checkbox' }}
                id='activate'
              />
            );
          },
        },
      },
      {
        name: 'delete',
        label: `${t('unassign')}`,
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowIndex;
            return (
              <div className={this.props.classes.columnWidth200}>
                <LinkOffIcon
                  style={{ cursor: 'pointer' }}
                  className={this.props.classes.icon}
                  onClick={() => this.handleDeleteChange(row)}
                  id='unassign'
                />
              </div>
            );
          },
        },
      },
    ];

    let { data, devices } = this.props.patient.toJS();
    let devicesList = (devices.list || []).map((item) => ({
      label: `${item.name || 'device name'} (${item.serial || 'serial number'})`,
      value: item.id,
    }));

    return (
      <Dialog
        open={state.dialogDevice.open}
        onClose={this.props.handleClose}
        aria-labelledby='form-dialog-title'
        maxWidth='md'
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 8,
          },
        }}
      >
        <DialogTitle className='header' id='form-dialog-title'>
          <Grid container style={{ position: 'relative' }}>
            <div>
              {t('assign_device_to')} <span className='headerMain'>{fullname}</span>
            </div>
            <div className='closeIcon' onClick={this.props.handleClose}>
              <svg width='32' height='32' viewBox='0 0 32 32'>
                <use xlinkHref={`/images/menus-v1.svg#close`} />
              </svg>
            </div>
          </Grid>
        </DialogTitle>
        <DialogContent style={{ height: '300px' }}>
          <Grid container item xs={12} spacing={8}>
            <Grid item xs={4} sm={4} className='deviceSelect'>
              <IntegrationReactSelect
                value={category || null}
                handleChange={this.onSelectCategory}
                options={categories}
                label={t('please_select_deviceType')}
                isSeparator={true}
              />
            </Grid>

            <Grid item xs={8} className='deviceSelect'>
              <IntegrationReactSelect
                value={devices.selected.label || null}
                handleChange={this.onDeviceChange}
                options={devicesList}
                label={t('please_select_device')}
                assignText={t('assign')}
                handleAddDevice={this.handleAddDevice}
                displayButton={true}
                isClearable={true}
                isSeparator={true}
              />
            </Grid>
            <Grid item xs={12}>
              <MUIDataTable
                data={data.patient.devices}
                columns={columns}
                searchable={false}
                options={{
                  viewColumns: false,
                  filter: false,
                  sort: false,
                  download: false,
                  print: false,
                  pagination: false,
                  selectableRowsOnClick: false,
                  selectableRows: 'none',
                  searchable: false,
                  search: false,
                  responsive: 'scrollFullHeight',
                  rowsPerPage: 5,
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            item
            style={{
              margin: '10px 28px',
              justifyContent: 'right',
            }}
          >
            <Button
              onClick={this.handleSubmit}
              color='primary'
              id='save'
              variant='contained'
              style={{
                width: 100,
              }}
            >
              {t('save')}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

export const page = inject('dashboard', 'patient', 'device', 'deviceType')(observer(Devices));
export const translation = withTranslation()(page);
export default withStyles({ withTheme: true })(translation);
